import brandPortalOrders from "@faire/web-api/routes/brand-portal/orders";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";
export var CannotFindAnOrderIA = function CannotFindAnOrderIA() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "qs+yOq",
    defaultMessage: [{
      "type": 0,
      "value": "Er zijn verschillende redenen waarom je een bestelling van een retailer niet kunt vinden in je Faire-account. Hier zijn enkele stappen die je kunt nemen om dit probleem aan te pakken:"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "8Hf+hC",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Bestelling nog in behandeling:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "+J5CGL",
    defaultMessage: [{
      "type": 0,
      "value": "Laat de retailer eventuele aanvullende gegevens over zijn of haar account verstrekken en moedig hem of haar aan om rechtstreeks contact met ons op te nemen voor meer hulp."
    }]
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "Q7Q0DJ",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Verschillende bestelnummers:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "s5nkQH",
    defaultMessage: [{
      "type": 0,
      "value": "Als een retailer je een bestelnummer geeft dat niet op de pagina "
    }, {
      "children": [{
        "type": 0,
        "value": "Bestellingen"
      }],
      "type": 8,
      "value": "LinkFormatting"
    }, {
      "type": 0,
      "value": " staat, vraag hem of haar dan om het "
    }, {
      "children": [{
        "type": 0,
        "value": "factuurnummer"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ". Het factuurnummer moet overeenkomen met het bestelnummer dat jij gekregen hebt. Op die manier kun je de bestelling vinden."
    }],
    values: {
      LinkFormatting: function LinkFormatting(chunks) {
        return OrderLinkFormatting(chunks);
      },
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 3
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "JDfmRL",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Nieuwe accounts die worden beoordeeld:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "PDY+PO",
    defaultMessage: [{
      "type": 0,
      "value": "Als een retailer zijn of haar factuurnummer heeft opgegeven, maar je de bestelling nog steeds niet kunt vinden, is het mogelijk dat de retailer een nieuw account heeft dat in de wacht staat terwijl ons team zijn of haar gegevens controleert. Dit controleproces zal niet langer dan enkele dagen duren."
    }]
  })))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "IkPzxw",
    defaultMessage: [{
      "type": 0,
      "value": "Als je het bovenstaande hebt gecontroleerd en de bestelling nog steeds niet kunt vinden, neem dan contact met ons op voor meer hulp. We helpen je graag verder."
    }]
  })));
};
var OrderLinkFormatting = function OrderLinkFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalOrders(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};